import {create} from 'zustand';

interface DomainValue {
  domainName:string;
  domainId:string
}

interface DomainState {
  domainValue:DomainValue;
  updateDomain:(newDomain:DomainValue) => void;
}

const useDomainStore = create<DomainState>((set)=>({
  domainValue:{
    domainName:'',
    domainId:'',
  },
  updateDomain:(newDomain) => set((state) => ({domainValue:{...newDomain}}))
}))

export default useDomainStore;
